import styled from 'styled-components';
import { EBalancesTheme } from 'utils/enums';

interface IStyledPlayerLevelImgProps {
  balanceTheme?: EBalancesTheme;
}

export const StyledPlayerLevelImg = styled.div<IStyledPlayerLevelImgProps>`
  height: 20px;
  width: auto;
  margin-right: 5px;
  box-sizing: border-box;

  .player-level-img {
    height: 20px;
    max-width: 80px;
    object-fit: contain;
  }

  &.ghost {
    border-radius: 16px;
    border: 1px solid #6701e1;
    background: #000;
    width: 48px;
    height: 14px;
    display: flex;
    align-items: center;

    .player-level-img {
      height: 16px;
      width: auto;
      left: -2px;
      position: relative;
    }
  }

  &.me2on {
    order: 1;
    margin-right: 0;
  }
`;
